import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Container, Input, Label, Row } from "reactstrap"
import { withRouter } from "react-router-dom"
import PropTypes from "prop-types"
import cresusFond from "../../assets/images/cresuFond.jpg"
import { Grid } from "react-loader-spinner"
import APIS from "../../apis"
import { ToastContainer, toast, Flip } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import axios from "axios"

const Redirection = props => {
  const [cin, setCin] = useState("")
  const [loading, setLoading] = useState(false)
  const [annee, setAnnee] = useState("")
  const [anneeName, setAnneeName] = useState("")

  // Récupérer l'année au montage
  useEffect(() => {
    const fetchAnnee = async () => {
      try {
        const resA = await axios.get(
            "https://scolarite.backcresus-institut.ovh/api/annee"
        )
        const resAnnee = await axios.post(
            "https://scolarite.backcresus-institut.ovh/api/annee/get_by_id",
            { id: resA.data.Annee[0].CurrentAnnee[0].value }
        )

        setAnnee(resAnnee.data.Annee.id)
        setAnneeName(resAnnee.data.Annee.annee_scolaire)
      } catch (err) {
        console.error("Erreur lors de la récupération de l'année", err)
        toast.error("❌ Impossible de récupérer l'année scolaire", {
          containerId: "A",
        })
      }
    }

    fetchAnnee()
  }, [])

  // Vérification du CIN
  const verifCin = async () => {
    if (!cin) {
      toast.warn("⚠️ Veuillez entrer votre CIN !", { containerId: "A" })
      return
    }

    setLoading(true)
    try {
      const res = await APIS.post(
          "renseignement/verif_cin",
          { cin ,annee_id:annee},
          {
            headers: {
              "X-Frame-Options": "DENY",
              annee: annee,
              "Content-Type": "application/json",
            },
          }
      )

      if (res.data.status === 200) {
        props.history.push("/DetailIns?cin=" + cin)
      } else {
        toast.error("⛔ Veuillez vérifier votre CIN !", { containerId: "A" })
      }
    } catch (err) {
      console.error("Erreur lors de la vérification du CIN", err)
      toast.error("❌ Erreur serveur", { containerId: "A" })
    } finally {
      setLoading(false)
    }
  }

  return (
      <div>
        {!loading ? (
            <div
                style={{
                  backgroundImage: `url(${cresusFond})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: "100vh",
                  width: "100vw",
                }}
            >
              <div style={{ paddingTop: "7%" }}>
                <Container>
                  <Row className="justify-content-center">
                    <Col md={8} lg={6} xl={5}>
                      <Card className="overflow-hidden">
                        <Row>
                          <Col className="justify-content-center pt-4">
                            <h3 style={{ color: "#485ec4", textAlign: "center" }}>
                              <p>FICHE DES RENSEIGNEMENTS</p>
                              <p>A.U {anneeName}</p>
                            </h3>
                          </Col>
                        </Row>
                        <CardBody className="pt-4">
                          <Col lg="12">
                            <div className="mb-3">
                              <Label>
                                CIN/ N° Passeport pour les étrangers :
                              </Label>
                              <Input
                                  placeholder="Entrer CIN/ N° Passeport"
                                  type="text"
                                  className="form-control"
                                  value={cin}
                                  onChange={e => setCin(e.target.value)}
                              />
                            </div>
                          </Col>
                          <div className="p-2">
                            <div className="mt-3 d-grid">
                              <button
                                  onClick={verifCin}
                                  className="btn btn-primary btn-block"
                                  type="button"
                              >
                                Connexion
                              </button>
                            </div>
                          </div>
                        </CardBody>
                        <div className="mt-1 text-center">
                          <p>
                            © {new Date().getFullYear()} Cresus. Crafted with{" "}
                            <i className="mdi mdi-heart text-danger" /> by{" "}
                            <a href="https://cresus.pro/">cresus.pro</a>
                          </p>
                        </div>
                      </Card>
                    </Col>
                  </Row>
                </Container>
                <ToastContainer
                    transition={Flip}
                    enableMultiContainer
                    containerId="A"
                    position={toast.POSITION.TOP_RIGHT}
                    autoClose={2500}
                />
              </div>
            </div>
        ) : (
            <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-50px",
                  marginLeft: "-50px",
                }}
            >
              <Grid height="100" width="100" color="#86B5E9" ariaLabel="loading" />
            </div>
        )}
      </div>
  )
}

Redirection.propTypes = {
  history: PropTypes.object,
}

export default withRouter(Redirection)
